import type { MantineTheme } from '@mantine/core';
import type { ProfitAndLossRow } from './useProfitAndLossTableQuery';
import { PROFIT_AND_LOSS_MAX_DEPTH } from './_utils';

export const getProfitAndLossTableCellStyle = (
  theme: MantineTheme,
  { rowDepth, type }: { rowDepth: number; type: ProfitAndLossRow['type'] }
) => {
  const depth = PROFIT_AND_LOSS_MAX_DEPTH - rowDepth;

  const bg = theme.colors.gray[depth];

  if (bg && type !== 'account') {
    return {
      backgroundColor: `${bg}!important`,
      fontWeight: 'bold',
    };
  }

  return {
    backgroundColor: `${theme.white}!important`,
    fontWeight: 'normal',
  };
};
